import ChevronRightSVG from "@design-system/ui-icons/vanilla/ChevronRight"
import { createIcon } from "../createIcon"

export const ChevronRightIcon = createIcon(ChevronRightSVG)
